module.exports = __webpack_public_path__ + "static/media/icon-tick.c4bdf6ce.svg";